import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { ConfirmEditPhoneNumberDialogComponent } from '../confirm-edit-phone-number-dialog/confirm-edit-phone-number-dialog.component';
import { ChangePasswordDialogComponent } from '../change-password-dialog/change-password-dialog.component';
import { environment } from '@app-environments/environment';

@Component({
  selector: 'app-verify-otp-via-change-password-dialog',
  templateUrl: './verify-otp-via-change-password-dialog.component.html',
  styleUrls: ['./verify-otp-via-change-password-dialog.component.css']
})
export class VerifyOtpViaChangePasswordDialogComponent implements AfterViewInit {
  seconds:number= 60;
  counter: any;
  hideVerifyOtp = false;
  form: FormGroup;
  @ViewChild('ngOtpInput') ngOtpInputRef:any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  timer: any;
  errorMessage: any;
  userData: any;
  count = 0;
  validateOtpCounter = 0;
  interval: any;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;
  constructor(public signUpService: SignupService,
    private userService: UserService,
    public router: Router,
    private testListService: TestlistService,
    private dialog: MatDialog, private fb:FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VerifyOtpViaChangePasswordDialogComponent>,
    private dialogRef2: MatDialogRef<ChangePasswordDialogComponent>) {
      this.form=fb.group({
        otp:[null],
      });
      dialogRef.disableClose = true;
     }

  ngOnInit(): void {
    this.userData = this.data;
    console.log(this.userData);
    this.form=this.fb.group({
      otp:[null],
    });
    this.dialogRef.disableClose = true;
  }
  onOtpChange(event:any){
    if(event.length===4) {
      this.form.get('otp')?.setValue(event);
      document.getElementById('verifyOtp')?.focus();
    }
  }

  validateOtp(): void {
    let payload = {
      countryCode: this.data.countryCode, 
      phone: this.data.phone, 
      otp: this.form.value.otp, 
      register: false,
      "userActivityTrackingDataDto": !this.sendTrackAPIOnSignInOrSignUp 
      ? undefined 
      : {
        "data": {},
        "landingPage": ""
      },
    };
    this.signUpService.validateOtp(payload).subscribe((data) => {
      if(data.accessToken){
        console.log('JWT token',data);
        localStorage.setItem('token', data.accessToken)
        this.editPassword(this.data.userObject, this.data.password)
      }
    },
      (error) => {                                     // on error
        this.errorMessage = error.error.message
      });
  }

editPassword(val: any, password: any): any {
    const obj = val;
    this.userService.updatePassword(password,obj.userId).subscribe((data: any) => {
    this.dialogRef.close(`${password}`);
    this.openPhoneNumberUpdatedConfirmDialog(password);
    },
    (error: any) => {                                     // on error
      alert(error.error.message);
    });
}

openPhoneNumberUpdatedConfirmDialog(password: any) {
  const config: MatDialogConfig = {
    width: '487px',
    height: '292px',
    data: { message: 'Password updated', message2: `Your have changed your password successfully` }
  };
  const dialogRef = this.dialog.open(ConfirmEditPhoneNumberDialogComponent, config);
  dialogRef.afterClosed().subscribe((value) => {
    if (value === true) {
      console.log('v', value)
      this.dialogRef.close(`${password}`);
      this.dialog.closeAll()
    }
  });
}

  verifyOtp(): void {
    if (this.form.value) {
      this.dialogRef.close(this.form.value);
    } else {
    }
  }

  onConfigChange(val: boolean) {
    console.log(val);
    this.config.isPasswordInput = val;
  }

  startCountdown(seconds : any) {

    this.counter = seconds;
    this.interval = setInterval(() => {
      this.counter--;
      if (this.counter == 0) {
       this.hideVerifyOtp = true;
        clearInterval(this.interval);
        document.getElementById('resendOtp')?.focus()
      }
      if(this.counter < 10) {
        this.counter = '0'+this.counter
      }
    }, 1000);
  }

  resendOTP() {
    if(this.count >= 25){
      alert('You have reached maximum of 5 attempts')
    } else {
      this.signUpService.generateOtp(this.userData, this.userData.countryCode).subscribe((data:any) => {
        console.log(data);
        this.count = this.count + 1;
        this.startCountdown(this.seconds);
        this.hideVerifyOtp = false;
      });
    }
  }

  ngAfterViewInit(): void {
    this.startCountdown(this.seconds);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  closeDialogue() {
    this.dialogRef.close();
  }
}

